import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export const dateLessThanValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const startDate = control.get('startDate');
    const endDate = control.get('endDate');
    
    if (startDate.value > endDate.value) {
      return {
        // dates: 'Date from must be less than Date to'
        'dateLessThan': true
      };
    }
    return {};
};
